import { Text } from 'foundations-components/components/Text';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Header } from 'foundations-components/transitional/components/Header';
import { jsx as _jsx } from "react/jsx-runtime";
export const SavedAssetsContainer = () => {
  return /*#__PURE__*/_jsx(Header, {
    use: "condensed",
    title: /*#__PURE__*/_jsx(Text, {
      typography: "heading-400",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "smartLibrary.savedAssets.title"
      })
    })
  });
};